import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { TableTeacher } from "../../../components/Users/TableTeachers/TableTeacher";
import { useAuth } from "../../../hook/userAuth";
import { AddEditTeachers } from "../../../components/Users/TableTeachers/AddEditTeachers";
import HeaderPage from "../../../components/HeaderPage/HeaderPage";
import ModalBasic from "../../../components/ModalBasic/ModalBasic";
import { Navigate, useNavigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader } from "semantic-ui-react";
import Swal from "sweetalert2";

function GestionDocente() {
  const { auth } = useAuth();
  if (!auth?.me?.is_superuser) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaGestionDocente />;
}
function LogicaGestionDocente() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(false);
  const [teachers, setTeachers] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [loading, setLoading] = useState(true);

  const openCloseModal = () => setShowModal((prev) => !prev);

  async function getUsersApi() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/users/?es_docente=true`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const result = response.data;
      setLoading(false);
      setTeachers(result);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getUsersApi();
    // eslint-disable-next-line
  }, [refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const ondelete = async (datosUsuario) => {
    const confirmMessage = `¿Seguro que desea eliminar definitivamente al docente ${datosUsuario.first_name} ${datosUsuario.last_name}?
    Esto eliminara todos sus registros del sistema (Esta acción no se puede deshacer)`;

    const result = await Swal.fire({
      //title: '¿Estás seguro?',
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${BASE_API}/api/users/${datosUsuario.id}/`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );

        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {
        window.location.reload();
        window.location.href = "/Login";
      }
    }
  };
  const createPersonalCE = () => {
    setTitleModal("Nuevo personal Docente");
    setContentModal(
      <AddEditTeachers onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updatePersonalDocente = (data) => {
    setTitleModal("Actualizar datos Personal Docente");
    setContentModal(
      <AddEditTeachers
        onClose={openCloseModal}
        onRefetch={onRefetch}
        Teacher={data}
      />
    );
    openCloseModal();
  };

  const asignarCursos = async (data) => {
    navigate("/gestion-docente/asignacion-cursos", {
      state: { dataDocente: data },
    });
  };

  return (
    <div>
      <div>
        <h1 className="tituloin">Gestión docente</h1>
      </div>
      <HeaderPage
        btnTitulo="Registrar Personal Docente"
        btnClick={createPersonalCE}
      />

      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <TableTeacher
          teachers={teachers}
          deleteTeacher={ondelete}
          updateTeacher={updatePersonalDocente}
          usuarioActual={auth.me}
          asignarCursos={asignarCursos}
        />
      )}

      <ModalBasic
        show={showModal}
        title={titleModal}
        children={contentModal}
        close={openCloseModal}
      />
    </div>
  );
}
export default GestionDocente;
